<template>
	<div class="exercise-other">
		<div class="exercise-subject__list" v-if="dataSource && dataSource.length > 0">
		    <div class="item border-rd-4" v-for="(item, index) of dataSource" :key="index">
		        <div class="item__head">
		          	<h2 class="font-size-16 primary-color-txt font-sanpro-semibold margin-0" @click="goToExerciseDetail(item, type)">{{item.title}}</h2>
		        </div>
		        <div class="item__body" v-if="item.listChapterChild && item.listChapterChild.length>0">
		          	<ul class="margin-0 p-0 display-flex-wrap">
		            	<li v-for="(child, index1) of item.listChapterChild" :key="index1">
			            	<a href="javascript:;" @click="goToExerciseDetail(child, type)">
			            		{{ child.title }}
			            	</a>
		            	</li>
		          	</ul>
		        </div>
		    </div>
		</div>
		<p v-else class="m-3 secondary-color-txt text-center font-size-20">
			Đang cập nhật dữ liệu lên hệ thống
		</p>
	</div>
</template>
<script>
	import { mapActions, mapGetters } from "vuex"
	import { STORE_KEY, TYPE_EXERCISE_OTHER, TYPE_EXERCISE_THEMATIC } from "../../_store/constants"
	import { APP_CONFIG } from "@/utils/constants"

	export default {
		name: 'ExerciseSubject',
		props: {
			dataSource: Array,
      type: Number
		},
		data () {
			return {
				classId: this.$route.params.classId,
				subjectId: this.$route.params.subjectId,
			}
		},
		computed: {
			...mapGetters({
				getExerciseDetailNumber: STORE_KEY + '/getExerciseDetailNumber',
				practiceActive: STORE_KEY + "/practiceActive"
			}),
		},

		methods:{

			goToExerciseDetail(val, type) {
        let nameForRouter = type === TYPE_EXERCISE_THEMATIC ? 'exerciseThematicDetail' : 'exerciseOtherDetail'
        let queryParams = type === TYPE_EXERCISE_THEMATIC ? {cauhoi: 0} : {cauhoi: 1}
        this.$router.push({name: nameForRouter, params: {classId: val.classId, subjectId: val.subjectId, typeId: parseInt(this.$route.query.tab),id: val.chapterId }, query: queryParams})
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import './../../../../assets/scss/mixins';
	@import './../../../../assets/scss/variables';
	@import './../../../../assets/scss/general';

	.exercise-subject {
		padding: 50px 0;

		ul {
			li {
				@extend .list-style-none;
			}
		}

		&__sidebar {
			width: 27%;
			margin-right: 6%;

			ul {
				li {
					min-height: 36px;
					padding: 7px 18px;
					@extend .border-rd-8;
					margin-bottom: 2px;
					line-height: 1.2;

					a {
						@extend .secondary-color-txt;
					}

					&.active, &:hover {
						background: $btn_hover_color;
						a {
							@extend .primary-color;
							@extend .font-sanpro-semibold;
						}
					}
				}
			}
		}

		&__list {
			// width: 67%;

			.item {
				padding: 15px 24px 5px;
				background: $color_bg_gray_light;

				&__head {
					// border-bottom: 1px solid $secondary_text_color;
					padding-bottom: 10px;
				}

				&__body {
					padding: 10px 0;

					ul {
						li {
							width: 48%;
							display: inline-block;
							margin-bottom: 10px;

							&:nth-child(odd) {
								margin-right: 4%;
							}

							a {
								@extend .primary-color-txt;
                @extend .font-sanpro-light;

                &:hover {
                  @extend .primary-color;
                }
							}
						}
					}
				}

				&:not(:last-child) {
					margin-bottom: 20px;
				}
			}
		}

		@media screen and ( max-width: 991px ) {
			&__list {
				.item {
					&__body {
						ul {
							li {
								width: 100%;

								&:nth-child(odd) {
									margin-right: 0;
								}
							}
						}
					}
				}
			}
		}

		@media screen and ( max-width: 767px ) {
			&__wrap {
				display: block;
			}

			&__sidebar, &__list {
				width: 100%;
			}

			&__sidebar {
				margin: 0 0 20px 0;
			}
		}
	}
</style>
